export default {
  nav: {
    portfolio: "Widyos Portfolio",
    whyme: "Warum ich?",
    education: "Bildung",
    experience: "Erfahrung",
    organizational: "Organisation",
    events: "Veranstaltungen",
    portfolio_link: "Portfolio",
    skills: "Fähigkeiten",
    certificates: "Zertifikate",
    awards: "Auszeichnungen",
    contact: "Kontakt",
    downloadResume: "Lebenslauf herunterladen",
    downloadPortfolio: "Portfolio herunterladen",
    letsConnect: "Verbinden",
  },
  hero: {
    greeting: "Hallo!",
    name: "Ich bin Widyo Tri Cahya Utomo",
    nickname: "Dio",
    title: "DevOps Engineer | Dateningenieur",
    description: "DevOps Engineer am Apple Developer Institute, automatisiert AWS-Infrastruktur als Code mit Terraform und Ansible und baut CI/CD-Pipelines. Gestützt auf drei Jahre Enterprise-Data-Engineering — ETL/CDC, Cloud-Migrationen und Datenplattformen.",
    downloadResume: "Lebenslauf herunterladen",
    contactMe: "Kontaktieren Sie mich",
  },
  whyme: {
    title: "Warum ich?",
    subtitle: "Was mich als DevOps Engineer auszeichnet",
    content: "Ich verschiebe nicht nur Daten – ich verwandle sie in Intelligenz, die echten Geschäftswert schafft. Ich gehe jedes Problem mit neugieriger Skepsis an, validiere Annahmen und entwickle Systeme, die skalieren, zuverlässig bleiben und tatsächlich Ergebnisse liefern. Meine Erfahrung umfasst End-to-End-Datenengineering, einschließlich Erfassung, Warehousing, Orchestrierung, Governance und Performance-Tuning über moderne Stacks hinweg. Ich habe in Unternehmensumgebungen gearbeitet, in denen Versagen keine Option ist, daher sind Zuverlässigkeit, Sicherheit und Präzision nicht verhandelbar. Ich bin besessen von sauberer Architektur, effizienten Pipelines und Automatisierung, die Kopfschmerzen verhindert – nicht verursacht. Mit über 40 Branchenzertifizierungen und einem zukunftsorientierten Fokus auf KI und Web3 baue ich Systeme, die für die heutigen Anforderungen und die Innovation von morgen konzipiert sind. Einfach ausgedrückt: Ich liefere Datenlösungen, die für Wirkung, Skalierung und Zukunft gebaut sind.",
  },
  tools: {
    title: "Hier sind einige der Werkzeuge und Technologien, die ich täglich verwende",
  },
  education: {
    title: "Bildung",
    subtitle: "Akademische Grundlage in Computertechnik mit starkem Fokus auf Datensysteme",
    graduated: "Abgeschlossen",
    institutions: {
      maranatha: {
        name: "Maranatha Christliche Universität",
        degree: "Bachelor of Engineering (B.E.), Computertechnik",
        highlights: [
          "GPA: 3.83",
          "Relevante Kurse: Datenbanken, Betriebssysteme, Computernetzwerke",
        ],
      },
      yosuka: {
        name: "Yos Sudarso Gymnasium - Karawang",
        degree: "Mathematik & Naturwissenschaften",
        status: "Abitur",
      },
      akademicrypto: {
        name: "Akademi Crypto - Tangerang",
        degree: "Nicht-Abschluss-Programm in Web3 und Blockchain",
        status: "März 2024 - Heute",
        highlights: [
          "Fokus auf Web3, Blockchain-Grundlagen und dezentrale Technologien",
          "Aktives Lernen in Kryptoökonomie, Smart Contracts und DeFi-Ökosystemen",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - Jakarta",
        degree: "Nicht-Abschluss-Programm in Finanzhandel und Marktanalyse",
        status: "Sep 2025 - Heute",
        highlights: [
          "Fokus auf Kryptowährungshandel mit Fundamental- und technischer Analyse",
          "Entwicklung praktischer Handelsstrategien und Marktbewertungsfähigkeiten durch Community-Lernen",
        ],
      },
    },
  },
  experience: {
    title: "Erfahrung",
    subtitle: "Automatisierung von Cloud-Infrastruktur sowie Enterprise-Daten-Engineering und technische Beratung in verschiedenen Branchen",
  },
  organizational: {
    title: "Organisation & Gemeinschaft",
    subtitle: "Führungsrollen und aktive Teilnahme an professionellen Organisationen und Gemeinschaften",
    activities: [
      {
        title: "Universitätsführung",
        organization: "Maranatha Christliche Universität",
        role: "Leiter des Digitalen Computerlabors",
        dates: "Apr 2021 – Apr 2023",
        description: "Leitete das Labor, verwaltete Projekte und Studentenbetreuung.",
      },
      {
        title: "Krypto-Gemeinschaften",
        organization: "Akademi Crypto, TradeWithSuli, Coin Kami",
        role: "Aktives Mitglied",
        dates: "Feb 2023 - Heute",
        description: "Aktiver Teilnehmer und lebenslanger Lernender in Web3- und Krypto-Communities.",
      },
      {
        title: "Connect Group und Multimedia-Dienst",
        organization: "Rose of Sharon Kirche",
        role: "Aktives Mitglied",
        dates: "Aug 2015 - Heute",
        description: "Aktiv in der Kirchengemeinde durch Connect Group Fellowship und Dienst im Multimedia-Dienst, Unterstützung von Gottesdiensten und kreativer Medienproduktion.",
      },
    ],
  },
  events: {
    title: "Veranstaltungen & Galerie",
    subtitle: "Fotos und Highlights von Veranstaltungen, Konferenzen, Seminaren und beruflichen Aktivitäten",
    noImages: "Keine Bilder verfügbar",
    maintenance: "In Wartung",
    maintenanceDesc: "Dieser Bereich wird derzeit mit neuen Inhalten aktualisiert. Bitte schauen Sie bald wieder vorbei!",
  },
  portfolio: {
    title: "Portfolio",
    subtitle: "Ausgewählte Projekte, die Webentwicklung und Daten-Engineering-Arbeit zeigen",
    webPortfolioTitle: "Web-Portfolio",
    dataPortfolioTitle: "Daten-Engineering-Portfolio",
    viewLive: "Live ansehen",
    explore: "Erkunden",
    showMore: "Mehr anzeigen",
    showLess: "Weniger anzeigen",
    downloadPdf: "Portfolio als PDF herunterladen",
    generatingPdf: "PDF wird erstellt...",
    selectProjects: "Projekte auswählen",
    selectAll: "Alle auswählen",
    cancel: "Abbrechen",
    downloadSelected: "Herunterladen",
    webProjects: [
      {
        title: "Maju Cipta Karya Website",
        description: "Maju Mapan ist eine moderne Möbelmarke, die elegantes Design mit Nachhaltigkeit verbindet. Jedes Stück wird von lokalen Handwerkern mit umweltfreundlichen Materialien handgefertigt und bringt Komfort, Gleichgewicht und Wärme in jeden Wohnraum.",
      },
      {
        title: "Tcuber Store Website",
        description: "Tcuber Store ist eine vertrauenswürdige Online-Spielaufladungsplattform in Indonesien, die schnelle, sichere und erschwingliche digitale Credits für beliebte Spiele wie Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans und PUBG Mobile bereitstellt. Wir bieten verschiedene Zahlungsmethoden und reaktionsschnellen Support, um ein reibungsloses Spielerlebnis zu gewährleisten.",
      },
    ],
    dataProjects: [
      {
        title: "Pinguindatenanalyse mit AI",
        description: "KI-gestütztes interaktives Datenexplorationstool. Analysieren Sie Pinguinartdaten mit natürlichsprachigen Fragen und visualisieren Sie Erkenntnisse durch dynamische Diagramme. Erstellt mit React, Recharts und Lovable AI.",
      },
    ],
    penguinExplorer: {
      title: "Fragen über Pinguine",
      selectQuestion: "Was möchten Sie wissen?",
      submit: "Absenden",
      analyzing: "Analysiere...",
      thinking: "Denke nach...",
      errorLoading: "Fehler beim Laden der Pinguindaten",
      errorAnalyzing: "Fehler bei der Datenanalyse",
      rateLimitError: "Ratenlimit überschritten. Bitte versuchen Sie es später erneut.",
      paymentError: "Zahlung erforderlich. Bitte fügen Sie Ihrem Lovable AI-Arbeitsbereich Credits hinzu.",
      speciesDistribution: "Artenverteilung",
      billVsBody: "Schnabellänge vs. Körpergewicht",
      dataTable: "Datenvorschau",
      questions: [
        "Welche Pinguine haben die längsten Schnäbel?",
        "Wo leben die schwersten Pinguine?",
        "Welche Pinguine haben die kürzesten Flossen?",
      ],
    },
  },
  skills: {
    title: "Fähigkeiten",
    subtitle: "Cloud-Infrastruktur, Automatisierung und CI/CD auf einer Basis aus Enterprise-Data-Engineering",
    categories: {
      cloud: "Cloud & Infrastruktur",
      iac: "IaC & GitOps",
      cicd: "CI/CD",
      containers: "Container & Observability",
      security: "Sicherheit & Netzwerke",
      databases: "Datenbanken",
      etl: "ETL & Integration",
      programming: "Programmierung",
      soft: "Soft Skills",
    },
  },
  certificates: {
    title: "Dataiku-Zertifikate",
    subtitle: "Professionelle Zertifizierungen in Data Science, Machine Learning und AI von Dataiku",
    clickToView: "Klicken Sie, um das vollständige Zertifikat anzuzeigen",
    download: "Herunterladen",
    verify: "Überprüfen",
    preview: "Zertifikatvorschau",
  },
  awards: {
    title: "Auszeichnungen & Zertifizierungen",
    subtitle: "Professionelle Zertifizierungen über Datenplattformen, Cloud-Infrastruktur und AI-Technologien",
    view: "Ansehen",
  },
  contact: {
    title: "Kontaktieren Sie uns",
    subtitle: "Offen für Möglichkeiten, Zusammenarbeit und Sprechanfragen",
    info: "Kontaktinformationen",
    email: "E-Mail",
    phone: "Telefon",
    social: "Soziale Medien",
    sendMessage: "Nachricht senden",
    name: "Name",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "Nachricht",
    messagePlaceholder: "Masukkan pesan",
    send: "Nachricht senden",
    copyright: "© 2025 Widyo Tri Cahya Utomo. Alle Rechte vorbehalten.",
  },
  whatsapp: {
    title: "Kontakt aufnehmen",
    subtitle: "Wählen Sie, wie Sie uns kontaktieren möchten",
    chatbot: "Chat mit KI-Assistent",
    whatsapp: "Nachricht über WhatsApp",
    defaultMessage: "Hallo Widyo! Ich würde gerne mit Ihnen in Kontakt treten.",
  },
  chatbot: {
    title: "KI-Assistent",
    welcome: "Hallo! Ich bin Widyos KI-Assistent. Ich kann Fragen zu seiner Erfahrung, seinen Fähigkeiten und Projekten beantworten. Wie kann ich Ihnen helfen?",
    placeholder: "Geben Sie Ihre Nachricht ein...",
    error: "Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  },
};
